import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getOrderDiscount } from "../../Helpers/promotions";
import MenuIcon from "@material-ui/icons/Menu";
import Summary from "./Summary";
import SmartPromotionProgressBar from "./SmartPromotionProgressBar";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";
class ActionButton extends Component {
  state = {
    openSummary: false,
  };


  static defaultProps = {
    action: "NO ACTION ASSIGNED",
  };
  getTotal = (price, total_discount) => {
    const { settings } = this.props;
    price -= total_discount;
    if (price <= 0) price = 0;
    return parseFloat(price).toFixed(settings.currency_decimals);
  };

  render() {
    const {
      language,
      settings,
      loading,
      OutOfStock,
      themeColor,
      smart_promos,
      appliedPromotions,
    } = this.props;
    const enable_quick_checkout = OutOfStock
      ? false
      : settings.enable_quick_checkout;
    if (settings.is_menu && !this.props.allowWithMenu) return <></>;
    const total_discount = getOrderDiscount(
      this.props.total,
      this.props.cart,
      this.props.applied_promo,
      this.props.discounts,
      this.props.smart_promos,
    );
    const checkForBuyNow =
      this.props.isDetailPage &&
      enable_quick_checkout &&
      this.props.enableBuyNow;

    const total = this.getTotal(this.props.total, total_discount);

    const showPromoProgressBar =
      !this.props.b2b &&
      smart_promos?.length === 1 &&
      !smart_promos[0].hide_promotion &&
      !appliedPromotions.find((p) => p.id === smart_promos[0].id);

    const currencyIcon = getCurrencyIcon(settings);

    return (
      <>
        {this.state.openSummary && (
          <Summary
            visible={this.state.openSummary}
            onClose={() => this.setState({ openSummary: false })}
            showNutrition={true}
            nutritionalFacts={this.props.getNutritionalFacts?.()}
            current_item={this.props.current_item}
            current_product={this.props.current_product}
          />
        )}

        {showPromoProgressBar && (
          <SmartPromotionProgressBar
            promotions={this.props.smart_promos}
            appliedCoupon={this.props.appliedCoupon}
            cart={this.props.cart}
            totalPrice={this.props.totalPrice}
            totalItems={this.props.totalItems}
            customerAddress={this.props.customerAddress}
            branch={this.props.branch}
            authUser={this.props.authUser}
            delivery={this.props.delivery}
          />
        )}

        <div
          style={{
            backgroundColor: "white",
            paddingBottom: 8,
            marginBottom: 0,
            height: 60,
            zIndex: this.props.isCartButton ? 3000 : 10,
            alignItems: "center",
            display: "flex",
            direction: language == "english" ? "ltr" : "rtl",
          }}
          className={`${
            language == "english"
              ? "action-button-english"
              : "action-button-arabic"
          } ${
            ((settings.enable_aseer_time ||
              settings.enable_loyalty_points_page) &&
              "action-button-tabs-space") ||
            ""
          }`}
        >
          {settings.show_nutrition_facts && this.props.fromProduct && (
            <MenuIcon
              style={{
                marginRight: language === "english" && 10,
                marginLeft: language === "arabic" && 10,
                color: themeColor,
                textAlign: "center",
                fontSize: 35,
              }}
              onClick={() => this.setState({ openSummary: true })}
            />
          )}
          <Button
            className={`mb-1  ml-1 mx-auto`}
            variant="contained"
            color="primary"
            disableFocusRipple={
              this.props.disabled ||
              this.props.placeOrderButtonDisabled ||
              loading
            }
            disableRipple={
              this.props.disabled ||
              this.props.placeOrderButtonDisabled ||
              loading
            }
            style={{
              width:
                checkForBuyNow && !settings.show_nutrition_facts
                  ? "50%"
                  : "97%",
              height: "100%",
              boxShadow: "none",
              textTransform: "none",
              backgroundColor:
                (this.props.disabled ||
                  this.props.placeOrderButtonDisabled ||
                  loading) &&
                "#9c9c9c",
            }}
            dir={language == "english" ? "ltr" : "rtl"}
            onClick={(e) =>
              !this.props.disabled &&
              !this.props.placeOrderButtonDisabled &&
              !loading
                ? this.props.onClick()
                : this.props.showCategoryMinOrder &&
                    !this.props.b2b &&
                    !this.props.addressPage
                  ? this.props.Show_Modal(e)
                  : null
            }
          >
            {this.props.quantity && (
              <span
                className="px-1"
                style={{
                  position: "absolute",
                  left: language == "english" && 10,
                  right: language == "arabic" && 10,
                  top: 6,
                  lineHeight: "34px",
                  background: "rgba(0, 0, 0, 0.3)",
                  borderRadius: 7,
                  minWidth: 32,
                  height: 32,
                  fontSize: "1rem",
                }}
              >
                {this.props.quantity}
              </span>
            )}
            {((!this.props.disabled && !this.props.minimumOrderValue) ||
              this.props.placeOrderButtonDisabled ||
              (this.props.disabled &&
                (this.props.addressPage || this.props.isDetailPage))) && (
              <span style={{ fontSize: "1rem" }}>
                {loading ? (
                  <CircularProgress
                    size={30}
                    style={{ marginTop: 8, color: "white" }}
                  />
                ) : (
                  this.props.action
                )}
              </span>
            )}
            {this.props.showCategoryMinOrder &&
            this.props.from_confirmation &&
            !this.props.minimumOrderValue ? (
              <div
                style={{ fontSize: "1rem" }}
                className={`${language === "english" ? "pr-1" : ""}`}
              >
                {language === "english"
                  ? "Minimum order not met"
                  : " لم تصل للحد الأدنى للطلب"}
                <HelpOutlineIcon
                  className="mx-1"
                  style={{
                    color: "white",
                  }}
                />
              </div>
            ) : this.props.from_confirmation &&
              settings.enable_special_remarks_files &&
              settings.special_remarks_files_required &&
              !this.props.promise.special_remarks_file_url ? (
              <div
                style={{ fontSize: "1rem" }}
                className={`${language === "english" ? "pr-1" : ""}`}
              >
                {language === "english"
                  ? `Please upload the ${this.props.customTexts.special_remarks_files}`
                  : `الرجاء تحميل ${this.props.customTexts.special_remarks_files_ar}`}
              </div>
            ) : this.props.disabled &&
              this.props.minimumOrderValue &&
              this.props.from_confirmation ? (
              <>
                <span
                  style={{
                    position: "absolute",
                    right: language == "english" && 89,
                    left: language == "arabic" && 89,
                    top: 2,
                    lineHeight: "20px",

                    borderRadius: 7,
                    minWidth: 32,
                    height: 20,
                    fontSize: "1rem",
                  }}
                >
                  {language == "english"
                    ? "Minimum order amount"
                    : "الحد الادنى للطلب"}
                </span>
                <span
                  style={{
                    position: "absolute",
                    right: language == "english" && 89,
                    left: language == "arabic" && 89,
                    top: 22,
                    lineHeight: "20px",

                    borderRadius: 7,
                    minWidth: 32,
                    height: 20,
                    fontSize: "1rem",
                  }}
                >
                  {language == "english" ? "Amount missing" : "المبلغ المتبقي"}
                </span>
              </>
            ) : this.props.disabled &&
              this.props.isPickup &&
              (this.props.carInfoIsRequired?.["make_is_required"] ||
                this.props.carInfoIsRequired?.["color_is_required"] ||
                this.props.carInfoIsRequired?.["plate_is_required"]) &&
              this.props.from_confirmation ? (
              <>
                <span>
                  {language == "english"
                    ? "Please fill your car information"
                    : "الرجاء ادخال معلومات سيارتك"}
                </span>
              </>
            ) : this.props.disabled &&
              this.props.promise.isGift &&
              (this.props.errorName || this.props.errorNumber) ? (
              <>
                <span>
                  {language == "english"
                    ? "Please fill the recipient information"
                    : "الرجاء ادخال معلومات المستلم"}
                </span>
              </>
            ) : null}

            {!this.props.minimumOrderValue &&
              this.props.total &&
              !this.props.from_confirmation && (
                <>
                  {parseFloat(this.props.total) > parseFloat(total) && (
                    <span
                      className={currencyIcon}
                      style={{
                        position: "absolute",
                        right: language == "english" && 17,
                        left: language == "arabic" && 17,
                        top: -9,
                        lineHeight: "34px",
                        textDecoration: "line-through",
                        borderRadius: 7,
                        minWidth: 32,
                        height: 32,
                        fontSize: "0.75rem",
                      }}
                    >
                      {this.props.total}{" "}
                      {language == "english"
                        ? settings?.currency_english
                        : settings?.currency_local}
                    </span>
                  )}
                  <span
                    className={
                      currencyIcon
                    }
                    style={{
                      position: "absolute",
                      right: language == "english" && 10,
                      left: language == "arabic" && 10,
                      top: 6,
                      lineHeight: "34px",
                      borderRadius: 7,
                      minWidth: 32,
                      height: 32,
                      fontSize: "1rem",
                    }}
                  >
                    {total}{" "}
                    {language == "english"
                      ? settings?.currency_english
                      : settings?.currency_local}
                  </span>
                </>
              )}
            {this.props.subTotal ? (
              checkForBuyNow && !settings.show_nutrition_facts ? (
                ""
              ) : (
                <span
                  className={`px-2 ${
                    currencyIcon
                  }`}
                  style={{
                    position: "absolute",
                    left: language == "arabic" && 10,
                    right: language == "english" && 10,
                    top: 6,
                    paddingLeft: "2px",
                    lineHeight: "34px",
                    background: "rgba(0, 0, 0, 0.3)",
                    borderRadius: 7,
                    minWidth: 32,
                    height: 32,
                    fontSize: "0.8rem",
                  }}
                >
                  {this.props.calculatedSubTotal?.toFixed(
                    settings.currency_decimals
                  )}{" "}
                  {language == "english"
                    ? settings?.currency_english
                    : settings?.currency_local}
                </span>
              )
            ) : null}
            {this.props.minimumOrderValue &&
              this.props.total &&
              this.props.disabled && (
                <>
                  <span
                    id="XD"
                    className={
                      currencyIcon
                    }
                    style={{
                      position: "absolute",
                      right: language == "english" && 10,
                      left: language == "arabic" && 10,
                      top: 2,
                      lineHeight: "20px",

                      borderRadius: 7,
                      minWidth: 32,
                      height: 20,
                      fontSize: "1rem",
                    }}
                  >
                    {this.props.minimumOrderValue.toFixed(
                      settings.currency_decimals,
                    )}{" "}
                    {language == "english"
                      ? settings?.currency_english
                      : settings?.currency_local}
                  </span>
                  <span
                    className={
                      currencyIcon
                    }
                    style={{
                      position: "absolute",
                      right: language == "english" && 10,
                      left: language == "arabic" && 10,
                      top: 22,
                      lineHeight: "20px",
                      borderRadius: 7,
                      minWidth: 32,
                      height: 20,
                      fontSize: "1rem",
                    }}
                  >
                    {(
                      parseFloat(this.props.minimumOrderValue) -
                      parseFloat(this.props.total)
                    ).toFixed(settings.currency_decimals)}{" "}
                    {language == "english"
                      ? settings?.currency_english
                      : settings?.currency_local}
                  </span>
                </>
              )}
          </Button>
          {checkForBuyNow && !settings.show_nutrition_facts && (
            <Button
              className={`mb-1 ${language == "english" ? "ml-1" : "mr-1"}`}
              color="primary"
              variant="contained"
              disableFocusRipple={
                this.props.disabled ||
                this.props.placeOrderButtonDisabled ||
                loading
              }
              disableRipple={
                this.props.disabled ||
                this.props.placeOrderButtonDisabled ||
                loading
              }
              onClick={() => this.props.onClickQuick()}
              style={{
                width: "50%",
                height: "100%",
                boxShadow: "none",
                textTransform: "none",
                backgroundColor: "#2ecc71",
                color: "white",
                display: "flex",
                justifyContent: "space-between",
                fontSize: "14px",
              }}
              dir={language == "english" ? "ltr" : "rtl"}
            >
              <span
                style={{
                  textAlign: "left",
                }}
              >
                {language == "english" ? "Buy now" : "اشتر الآن"}
              </span>
              <span
                className={`px-2 ${
                  currencyIcon
                }`}
                style={{
                  position: "absolute",
                  left: language == "arabic" && 10,
                  right: language == "english" && 10,
                  top: 6,
                  paddingLeft: "2px",
                  lineHeight: "34px",
                  background: "rgba(0, 0, 0, 0.3)",
                  borderRadius: 7,
                  minWidth: 32,
                  height: 32,
                  fontSize: "0.8rem",
                }}
              >
                {this.props.calculatedSubTotal?.toFixed(
                  settings.currency_decimals
                )}{" "}
                {language == "english"
                  ? settings?.currency_english
                  : settings?.currency_local}
              </span>
            </Button>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    applied_promo: state.cart.promos,
    discounts: state.cart.discounts,
    settings: state.store.store.settings,
    smart_promos: state.store.store.smart_promos,
    cart: state.cart.cart,
    themeColor: state.store.store.settings.dark,
    promise: state.promise,
    customTexts: state.store.store.settings.custom_texts,
    branch: state.branch,
    authUser: state.auth.user,
    delivery: state.delivery,
    customerAddress: state.customers.address,
    appliedCoupon: state.cart.promos,
    discounts: state.cart.discounts,
    totalPrice: state.cart.price,
    totalItems: state.cart.number_of_items,
    appliedPromotions: state.cart.smart_promos,
  };
};

export default connect(mapStateToProps)(ActionButton);
